import React, { useMemo } from 'react';

import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { useMaxZ } from 'ui-components/hooks/services/use-max-z';

import style from './header.module.less';
import { messages } from './messages';

export const Header = () => {
  const zIndex = useMaxZ();
  const zIndexStyle = useMemo(() => ({ zIndex }), [zIndex]);

  return (
    <FlexRow className={style.header} style={zIndexStyle}>
      <Text textType={TextType.H1} value={messages.header} />
    </FlexRow>
  );
};
